import { ChangeEvent } from "react";
import { Pagination } from "antd";
import type { PaginationProps } from "antd";

export type UIPaginationProps = Omit<
  PaginationProps,
  "onChange" | "current" | "total"
> & {
  page?: number;
  count?: number;
  shape?: string;
  color?: string;
  onChange?: (event: ChangeEvent<unknown>, page: number) => void;
};

export const UIPagination = ({
  page,
  count,
  onChange,
  shape,
  color,
  ...props
}: UIPaginationProps) => (
  <Pagination
    current={page}
    total={count}
    pageSize={1}
    onChange={(current) =>
      onChange?.(
        { preventDefault: () => undefined } as unknown as ChangeEvent<unknown>,
        current
      )
    }
    {...props}
  />
);
